var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDetails),expression:"showDetails"}]},[_c('img',{staticClass:"pdf-icon",attrs:{"src":require("@/assets/images/pdf.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }